// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchSelect_wrapper__2oBW7"};